'use client';
import classNames from 'classnames';
import useTranslation from '@repo/ui/src/context/Translation/useTranslation';
import Product from '@models/product';
import GrillCard from './_GrillCard';

interface Props {
  alternateSize: any;
  dark?: boolean;
  product: Product;
}

const AlternateSizes = ({ alternateSize, product, dark = false }: Props) => {
  const { t } = useTranslation();
  const altProduct = new Product(alternateSize);

  const alternateSizes = [altProduct, product]
    .filter(Boolean)
    .sort((a, b) => (a?.price > b?.price ? -1 : 1));

  if (!alternateSize) return null;

  return (
    <div className="tw-grid tw-gap-4 tw-mb-6">
      <h4 className={classNames('tra-text-web-utl-link', dark && 'tw-text-white')}>
        01 - {t('productDetailPageContent.selectSizeText', undefined, { default: 'Select a Size' })}
      </h4>
      <p className="sr-only">
        {alternateSizes?.length}{' '}
        {t('productDetailPageContent.sizesAvailableText', undefined, {
          default: 'sizes available',
        })}
        ,{' '}
        {t('productDetailPageContent.selectedOptionText', undefined, {
          default: 'selected option is',
        })}{' '}
        {product?.title}
      </p>
      <ul className="tw-p-0 tw-grid tw-grid-rows-2 tw-gap-4 tw-list-none">
        {alternateSizes?.map((prod, i) => (
          <GrillCard
            key={`alternate_size_item_${i}_${prod?.title}`}
            variation={prod}
            selected={product?.sku === prod?.sku}
          />
        ))}
      </ul>
    </div>
  );
};

export default AlternateSizes;
